import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import * as Util from "@/functions/Util";

export default class TipoCadastroTalhaoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (Util.isNull(model.descricao)) {
            validated = false;
            refs.descricaoInput.focusedOut = true;
        }
        
        return validated;
    }

}